import {
    Badge,
    Box,
    Button,
    Card,
    Container,
    Group,
    LoadingOverlay,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
} from '@mantine/core';
import {
    getUserRoutes,
    getUserVerticals,
    getVerticals,
} from '../../../../../http/apiClient';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchableSelect } from '../../../../common';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { hasRole } from '../../../../../utils/roles';
import { useAuthStore } from '../../../../../store';
import { useEffect } from 'react';

const VoicemailCampaignSubview = ({ form, campaign }) => {
    useEffect(() => {}, [campaign]);
    const userProfile = useAuthStore((state) => state.userProfile);

    //const { isPending, mutate: addOrUpdate } = useAddMessageGroup();
    const userQueryHttpFn = (queryHttpFn, queryParams) => {
        const userId = form.values.userId;
        const searchUserRoutes = hasRole(userProfile, 'SUPER_ADMIN') && userId;

        if (searchUserRoutes) {
            return queryHttpFn({
                userId,
                type: 'rvm',
                pagination: queryParams,
            });
        }
        return queryHttpFn({
            type: 'rvm',
            pagination: queryParams,
        });
    };

    return (
        <>
            <SearchableSelect
                label={'Route'}
                withAsterisk
                placeholder='Select sending route'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getUserRoutes, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['user_routes', 'rvm', form.values.userId]
                        : ['user_routes', 'rvm']
                }
                optionsMapFn={(route) => ({
                    label: route.name,
                    value: route.id.toString(),
                })}
                {...form.getInputProps('routeId')}
            />
        </>
    );
};
export default VoicemailCampaignSubview;
